// ip：192.168.63.43,192.168.63.43 网关：192.168.63.40,192.168.63.41
// 域名
// 项目所在地址
export const APP_DOMAIN = '//domp.bluemoon.com.cn/bd-portal-view/'
// 后台访问地址
export const BASE_PATH = '//domp.bluemoon.com.cn/bd-domp-service/'
export const LOGIN_PATH = '//domp.bluemoon.com.cn/bd-domp-service/'



// WEBPACK FOOTER //
// ./src/config/prod.config.js